import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/steam-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M185.2 356.5C192.9 338 184.2 316.8 165.6 309.1L136.1 296.9C147.5 292.6 160.4 292.4 172.5 297.4 184.7 302.5 194.1 312 199.2 324.1 204.2 336.3 204.2 349.7 199.1 361.8 188.6 386.9 159.7 398.8 134.5 388.3 122.9 383.5 114.1 374.7 109.1 364.1L137.6 375.9C156.2 383.7 177.5 375 185.2 356.5zM400 32H48C21.5 32 0 53.5 0 80V240.7L116.6 288.8C128.6 280.6 142.8 276.7 157.3 277.5L212.7 197.3V196.2C212.7 148 252 108.7 300.3 108.7S387.9 148 387.9 196.2C387.9 245.4 347 284.9 298.3 283.7L219.3 340C220.9 378.5 190.2 408.8 153.6 408.8 121.8 408.8 95.1 386.1 89.1 356.1L0 319.2V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM300.3 254.5C268.1 254.5 241.9 228.4 241.9 196.2S268.1 137.9 300.3 137.9 358.7 164.1 358.7 196.2 332.5 254.5 300.3 254.5zM300.4 239.9C324.6 239.9 344.3 220.3 344.3 196.1 344.3 171.9 324.7 152.3 300.4 152.3 276.2 152.3 256.5 171.9 256.5 196.1 256.5 220.3 276.2 239.9 300.4 239.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/steam-square.js
// module id = ZQck
// module chunks = 144